module.exports = __webpack_public_path__ + "img/update_back_img.c65d39c2.png";